<!-- Modal.svelte -->
<script>
    let { selectors, checkedValue, onUpdateValue } = $props();
</script>

<select class="selector" onchange={(e) => onUpdateValue(e.target.value)}>
    <option disabled>Select an option</option>
    {#each selectors as selector}
        {#if checkedValue === selector.value}
            <option selected value={selector.value}>{selector.text}</option>
        {:else}
            <option value={selector.value}>{selector.text}</option>
        {/if}
    {/each}
</select>

<style lang="scss">
    @use "./styles/index.scss";
</style>
